// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import Meta from 'vue-meta'
import MetaInfo from 'vue-meta-info';
import 'assets/css/style/reset.css'
import BaiduMap from 'vue-baidu-map'


Vue.config.productionTip = false
Vue.use(BaiduMap, {
  ak: 'FOTP9QFqSNfHUm0KthYDM3sfAWuQ1xHE'
});
Vue.use(MetaInfo);
Vue.directive('title', {//单个修改标题
  inserted: function (el, binding) {
    document.title = el.dataset.title
  }
})
if ((navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i))) {
  console.log("手机端");
  //window.location.href="m.36w.cn";
  window.location.href="https://m.36w.cn/"   
} else {
}
// router.beforeEach((to, from, next)=>{
//   if(to.meta.content) {     //路由发生变化时候修改meta中的content
//      //let head = document.getElementByTagName('head')
//      let meta = document.createElemnet('meta')
//      document.querySelector('meta[name="keywords"]').setAttribute('content',to.meta.content.keywords)
//      document.querySelector('meta[name="description"]').setAttribute('content',to.meta.content.description)
//      meta.content = to.meta.content
//      dead[0].appendChild(meta)
     
//   }
//   if(to.meta.title) {   //路由发生变化时候修改页面中的title
//       document.title = to.meta.title
//   }
//   next()
// })
/* eslint-disable no-new */
//路由守卫，控制头部组件点击跳转回到页面顶部
router.beforeEach((to, from, next) => {
  const {name}=to;
  const isLoginOrRegister=(name=='Home'||name=='JobWanted'||name=='Recruitment'||name=='Prorecruitment'||name=='About');
  if(isLoginOrRegister){
    // 让页面回到顶部
    document.documentElement.scrollTop = 0
    // 调用 next()，一定要调用 next 方法，否则钩子就不会被销毁
    next();
  }else{
    next();
  }
})
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>',
  // 这句非常重要，否则预渲染将不会启动 
  mounted () {
    document.dispatchEvent(new Event('render-event'))
}
})



// WEBPACK FOOTER //
// ./src/main.js